/**
 * Stable ordering for chat messages: time first, then role (user before assistant in ties),
 * then id. Used when realtime events arrive out of order or when created_at values collide.
 */
export interface ChatMessageOrderable {
  id: string;
  role: string;
  created_at?: string | null;
}

const ROLE_ORDER: Record<string, number> = {
  user: 0,
  assistant: 1,
  human_agent: 2,
  system: 3,
};

export function compareChatMessagesForDisplay(
  a: ChatMessageOrderable,
  b: ChatMessageOrderable
): number {
  const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
  const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
  if (ta !== tb) return ta - tb;
  const ra = ROLE_ORDER[a.role] ?? 99;
  const rb = ROLE_ORDER[b.role] ?? 99;
  if (ra !== rb) return ra - rb;
  return a.id.localeCompare(b.id);
}

export function sortChatMessagesForDisplay<T extends ChatMessageOrderable>(messages: T[]): T[] {
  return [...messages].sort(compareChatMessagesForDisplay);
}
